import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { HistoryArea } from '../models/HaPerCountry';
import { VarietyScores } from "../models/VarietyScore";

const rootPath = "/sitiagri-rest-api/api_basic/v1/dashboard"

export default class HaPerCountryApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getHistoryArea(): Promise<HistoryArea[]> {
        const res = await this.http.get(`${rootPath}/agreed_area`);
        return res.data;
    }

    public async getScores(pkCuaa: number, campaign: number): Promise<VarietyScores[]> {
        const res = await this.http.get(`${rootPath}/countries/${pkCuaa}/campaigns/${campaign}/varieties_score`);
        return res.data;
    }

}
